import Swiper from "swiper";
import { Navigation, Pagination, A11y, Autoplay, Thumbs, EffectCreative, Controller, EffectFade, } from "swiper/modules";
export { Swiper, Navigation, Pagination, A11y, Autoplay, Thumbs, EffectCreative, Controller, EffectFade, };
